export const STORE_SYNC_URL = "/store/sync";
export const STORE_GET_FULL = "/store/full";
